export default {
  name: 'Relatórios de Processamentos',
  children: [
    {
      name: 'Folha Mensal',
      children: [
        {
          name: 'Resumo da Folha Mensal',
          value: 'resumo-folha',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Resumo da Folha por Lotação',
          value: 'resumofolha-lotacao',
          options: {
            showStockingSelect: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Folha de Pagamento',
          value: 'folha-pagamento',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Folha de Pagamento de Adiantamento Salarial',
          value: 'resumofolha-adt',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Folha de Pagamento de Diretores',
          value: 'folhapagamento-diretor',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação Líquido para Bancos',
          value: 'relacao-bancos',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação de Adiantamento para Bancos',
          value: 'relacao-bancos-adt',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Ficha Financeira por Trabalhador',
          value: 'ficha-financeira',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateYearPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Ficha Financeira por Evento no Período',
          value: 'ficha-financeira-eveperiodo',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showEventSelect: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Ficha Financeira por Evento no Ano',
          value: 'ficha-financeira-eveano',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateYearPeriod: true,
            showEventSelect: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Folha Sintética',
          value: 'folha-sintetica',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação de Encargos',
          value: 'relacao-encargos',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Relação do IRRF',
          value: 'relacao-irrf',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação do INSS',
          value: 'relacao-inss',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação do FGTS',
          value: 'relacao-fgts',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Relação para Sindicato',
          value: 'relacao-sindicato',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação para Sindicato na Rescisão',
          value: 'relacao-sindicato-rescisao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Analítico DARF',
          value: 'analitico-darf',
          options: {
            showDateMonthPeriod: true,
          },
        },
        /*
        {
          name: 'Resumo da Folha por Tomador de Serviço',
          value: 'resumo-folha-tomador',
          options: {
            showDateMonthPeriod: true,
          },
        },
        */
      ],
    },
    {
      name: 'Férias',
      children: [
        {
          name: 'Resumo da Folha de Férias',
          value: 'resumofolha-ferias',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Resumo da Folha de Férias por Lotação',
          value: 'resumofolha-ferias-lotacao',
          options: {
            showStockingSelect: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Resumo do INSS nas Férias',
          value: 'relacao-inss-ferias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Provisão de Férias',
          value: 'COMPETENCE_VACATION_PROVISION',
          options: {
            hideOtherOptionsButton: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Mapa de Média nas Férias',
          value: 'ferias-mapamedias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Férias Vencidas e a Vencer',
          value: 'expired-vacation',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Trabalhadores em Férias',
          value: 'ferias-funcferias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Décimo Terceiro Salário',
      children: [
        {
          name: 'Provisão de Décimo Terceiro Salário',
          value: 'COMPETENCE_THIRTEENTH_SALARY_PROVISION',
          options: {
            hideOtherOptionsButton: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Resumo do Décimo Terceiro Salário',
          value: 'resumofolha-13sal',
          options: {
            showDateYearPeriod: true,
          },
        },
        {
          name: 'Folha de Pagamento do Décimo Terceiro Salário',
          value: 'folhapagamento-13sal',
          options: {
            showDateYearPeriod: true,
          },
        },
        {
          name: 'Mapa de Médias do Décimo Terceiro Salário',
          value: 'decter-mapamedias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateYearPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Relação Líquidos da 1ª Parcela para Bancos',
          value: 'relacao-bancos-131',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateYearPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação Líquidos da 2ª Parcela para Bancos',
          value: 'relacao-bancos-132',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateYearPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
      ],
    },
    {
      name: 'Rescisão de Contrato de Trabalho',
      children: [
        {
          name: 'Resumo da Folha de Rescisão',
          value: 'resumofolha-rescisao',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Resumo da Folha de Rescisão por Lotação',
          value: 'resumofolha-rescisao-lotacao',
          options: {
            showStockingSelect: true,
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Folha de Pagamento de Rescisão',
          value: 'folhapagamento-rescisao',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Mapa de Médias do Aviso Prévio Indenizado',
          value: 'rescisao-mapamedias',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
        {
          name: 'Analítico DARF na Rescisão',
          value: 'analitico-darf-rescisao',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Mapa de Médias do Décimo Terceiro Salário na Rescisão',
          value: 'decter-mapamedias-rescisao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },

        },
        {
          name: 'Mapa de Médias nas Férias na Rescisão',
          value: 'ferias-mapamedias-rescisao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showWorkerSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
          },
        },
      ],
    },
    {
      name: 'Benefícios',
      children: [
        {
          name: 'Relação de Vales Alimentação e Refeição',
          value: 'relacao-va',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação de Vales Alimentação',
          value: 'relacao-va-alimentacao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação de Vales Refeição',
          value: 'relacao-va-refeicao',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
        {
          name: 'Relação de Vales Transporte',
          value: 'relacao-vt',
          options: {
            showStockingSelect: true,
            showJobDescriptionSelect: true,
            showDateMonthPeriod: true,
            showGroupBy: true,
            showOrderBy: true,
          },
        },
      ],
    },
    {
      name: 'Autônomos',
      children: [
        {
          name: 'Resumo de Pagamento à Autônomos',
          value: 'SELF_EMPLOYED_PAYMENT_SUMMARY',
          options: {
            showDateMonthPeriod: true,
          },
        },
        {
          name: 'Folha de Pagamento a Autônomos',
          value: 'SELF_EMPLOYED_PAYMENT_LIST',
          options: {
            showDateMonthPeriod: true,
          },
        },
      ],
    },
  ],
};
